import * as React from 'react';
import { forEach, get, isEmpty } from 'lodash';
import { IQuotes } from '../../../../../../data/api/models';

interface IBenefit {
  quote: IQuotes;
  shortName?: string;
  displayName?: string;
  definition?: string;
  covered?: any
}

class Benefit extends React.Component<IBenefit> {

  private static getAllBenefits = (quote) => {
    let allBenefits = get(quote, 'scheme.allBenefits', []);

    if (!isEmpty(get(quote, 'information.all_benefits', []))) {
      allBenefits = get(quote, 'information.all_benefits', [])
    }

    return allBenefits;
  }

  public static getBenefits = (quote) => {
    const someBenefits = Benefit.getSomeBenefits(quote);
    const allBenefits = Benefit.getAllBenefits(quote);

    const benefitsWithoutWinterAndCruise = someBenefits.filter((el) => {
      return el.name !== 'Winter sports' && el.name !== 'Cruise cover';
    });

    const winterAndCruiseBenefits = allBenefits.filter((el) => {
      return el.name === 'Winter sports' || el.name === 'Cruise cover';
    });

    return [...benefitsWithoutWinterAndCruise, ...winterAndCruiseBenefits];

  };

  private static getSomeBenefits = (quote) => {
    let someBenefits = get(quote, 'benefits', []);

    if (!isEmpty(get(quote, 'information.all_benefits', []))) {
      const allBenefits = get(quote, 'information.all_benefits', [])
      someBenefits = [...allBenefits, ...someBenefits]
    }
    return someBenefits;

  }

  private getBenefit = (benefits: any[], displayName, type?: string, subBenefitName?: string, shortName?: string, coverLevel?: string) => {
    let displayBenefit = '';
    let displayBenefitDescription = '';
    let subBenefit = [];
    let displaySubBenefit = '';
    let displaySubBenefitDescription = '';

    if (!benefits) {
      return
    }

    benefits.forEach((benefit) => {
      if (benefit.displayName === displayName || benefit.name === displayName || benefit.display_name === displayName) {
        subBenefit = benefit.subBenefits || benefit.sub_benefits;
        displayBenefit = this.displayText(benefit, coverLevel);
        displayBenefitDescription = benefit.description;
      }

      if (shortName && (benefit.shortName === shortName || benefit.name === shortName || benefit.short_name === shortName)) {
        subBenefit = benefit.subBenefits || benefit.sub_benefits;
        displayBenefit = this.displayText(benefit, coverLevel);
        displayBenefitDescription = benefit.description;
      }

      forEach(subBenefit, (item) => {
        if (item.name === subBenefitName) {
          displaySubBenefit = item.text;
          displaySubBenefitDescription = item.description;
        }
      });
    });

    switch (type) {
      case 'subBenefit':
        return displaySubBenefit;
      case 'subBenefitDescription':
        return displaySubBenefitDescription;
      case 'description':
        return displayBenefitDescription;
      default:
        return displayBenefit;
    }
  }

  public displayText = (benefit, coverLevel): string => {
    let displayBenefit;
    if (benefit.cover_level_display && coverLevel) {
      displayBenefit = get(benefit, `cover_level_display.${coverLevel}`)
    }
    if (!displayBenefit) {
      displayBenefit = benefit.text;
    }

    return displayBenefit;
  }

  public render() {
    const { covered, quote, displayName, shortName } = this.props;
    let value;
    const allBenefits = Benefit.getBenefits(quote);
    const coverLevel: string = get(quote, 'scheme.cover_level');

    const benefitValue = (value) => {
      const { displayName } = this.props;

      // Gadget cover and golf cover return different values when not enabled for a tier. Gadget cover returns 'nil',
      // while golf cover returns 'n/a' when not enabled. Golf cover returns 'nil' when enabled.

      if ((displayName === 'Gadget cover')) {
        // Gadget cover is 'nil' when it is not available for this tier.
        // However if they select a tier where it is available on a latter screen and then go back,
        // it must check for that tier if it is available and that it is also covered.
        if (covered && value !== 'nil') {
          return 'Covered';
        }
        return 'Optional Extra';
      }

      if ((displayName === 'Golf cover')) {
        // Golf cover is 'n/a' when it is not available for this tier.
        // However if they select a tier where it is available on a latter screen and then go back,
        // it must check for that tier if it is available and that it is also covered.
        if (covered && value !== 'n/a') {
          return 'Covered';
        }
        return 'Not Covered';
      }

      if (displayName === 'Winter sports' || displayName === 'Cruise cover') {
        return covered ? 'Covered' : 'Not Covered';
      }

      return value === 'n/a' || value === 'nil' ? 'x' : value;
    };

    switch (displayName) {
      case 'Policy Excess':
        value = get(quote, 'information.standardExcess') || get(quote, 'information.standard_excess')
        break;
      case 'Winter sports':
        value = this.getBenefit(allBenefits, 'Winter sports')
        break;
      case 'Cruise cover':
        value = this.getBenefit(allBenefits, 'Cruise cover')
        break;
      case 'Excess Waiver':
        value = 'NA'
        break;
      case 'Personal accident':
        value = this.getBenefit(allBenefits, 'Personal Accident', 'subBenefit', 'Death benefit')
        break;
      case 'Hijack':
        value = this.getBenefit(allBenefits,
          'Hijack', 'subBenefit', 'Hijack benefit (£100 per day - over 24hrs)')
        break;
      case 'Single item limit':
        value = this.getBenefit(allBenefits, 'Baggage', 'subBenefit', 'single item limit')
        break;
      case 'Overall valuables limit':
        value = this.getBenefit(allBenefits, 'Baggage', 'subBenefit', 'valuables total limit')
        break;
      default:
        value = this.getBenefit(allBenefits, displayName, null, null, null, coverLevel)
        break;
    }

    if (shortName && !value) {
      value = this.getBenefit(allBenefits, null, '', '', shortName, coverLevel)
    }

    return (
      <>
        <div>
          <div>{benefitValue(value)}</div>
        </div>
      </>
    );
  }
}

export default Benefit;
